// extracted by mini-css-extract-plugin
export var currencyInput = "_nd-1";
export var currencySymbol = "_nd-0";